// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-historico-emails .v-data-table .v-data-footer {\n  display: none !important;\n}", ""]);
// Exports
module.exports = exports;
